var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.54,
    height: 16.54,
    viewBox: "0 0 16.54 16.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#208ce1;stroke:#208ce1;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.02,6a8.02,8.02,0,1,0,8.02,8.02A8.026,8.026,0,0,0,14.02,6Zm0,15.149a7.129,7.129,0,1,1,7.129-7.129A7.138,7.138,0,0,1,14.02,21.149Z",
    transform: "translate(-6 -6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.891,12H23v5.347a.46.46,0,0,0,.129.316L25.8,20.336l.628-.628-2.54-2.544Z",
    transform: "translate(-15.426 -9.327)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/timer_icon.233501f9ddf787ba7a8161948e38b20b.svg";
export { ForwardRef as ReactComponent };